import { createFileRoute } from "@tanstack/react-router";
import { TenantOverviewTab } from "../features/tenants/pages/tenant-overview-tab";

export const Route = createFileRoute("/tenants/$tenantId/")({
  component: TenantOverviewTab,
});
